import AppLogout from "./AppLogout";
import Dashboard from "./Dashboard";

const MainDashboardEntry = () => {
    return (
        <AppLogout>
            <Dashboard />
        </AppLogout>
    )
}
export default MainDashboardEntry